import React, { useCallback, useEffect, useState } from 'react';
import { Field, Input, Select } from '../ui/Field';
import { EtatEchec, Squelettes } from '../Organisation/EtatsPage';
import type { LigneJournal } from '../../lib/equipeApi';
import { useEquipe } from './EquipeShell';
import { dateCourte } from './droitsPhrase';

/** Journal d'activité (maquette L02-12) : actions sensibles, filtrables par personne, type et date. */
const TYPES = [['', 'Toutes les actions'], ['DROITS', 'Droits changés'], ['SENSIBLE', 'Données sensibles'], ['COMPTE', 'Comptes'], ['ACCES', "Demandes d'accès"], ['HTTP_DELETE', 'Suppressions']];

export const JournalPage: React.FC = () => {
    const { api } = useEquipe();
    const [lignes, setLignes] = useState<LigneJournal[] | null>(null);
    const [personnes, setPersonnes] = useState<{ id: string; name: string }[]>([]);
    const [erreur, setErreur] = useState<unknown>(null);
    const [f, setF] = useState({ personne: '', type: '', du: '', au: '' });

    const charger = useCallback(async () => {
        setErreur(null);
        try { const r = await api.journal(f); setLignes(r.lignes); setPersonnes(r.personnes); } catch (e) { setErreur(e); }
    }, [api, f]);
    useEffect(() => { void charger(); }, [charger]);

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                <Field label="Personne">{(x) => <Select {...x} value={f.personne} onChange={(e) => setF({ ...f, personne: e.target.value })}><option value="">Toutes</option>{personnes.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</Select>}</Field>
                <Field label="Type d'action">{(x) => <Select {...x} value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}>{TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</Select>}</Field>
                <Field label="Du">{(x) => <Input {...x} type="date" value={f.du} onChange={(e) => setF({ ...f, du: e.target.value })} />}</Field>
                <Field label="Au">{(x) => <Input {...x} type="date" value={f.au} onChange={(e) => setF({ ...f, au: e.target.value })} />}</Field>
            </div>
            {erreur ? <EtatEchec erreur={erreur} titre="Impossible d'afficher le journal" onRetry={charger} /> : !lignes ? <Squelettes lignes={4} /> : (
                <div className="bg-surface border border-border rounded-xl overflow-hidden">
                    {lignes.length === 0 && <p className="px-5 py-6 text-[13px] text-content-muted">Aucune action ne correspond à ces filtres.</p>}
                    {lignes.map((l) => (
                        <div key={l.id} className="px-5 py-3 border-b border-border-soft last:border-b-0">
                            <div className="text-[13px] text-content">{l.new_value || l.action}</div>
                            <div className="text-[11.5px] text-content-muted">{dateCourte(l.created_at)} · par {l.acteur}{l.cible ? ` · concerne ${l.cible}` : ''}</div>
                            {l.old_value && <div className="text-[11.5px] text-content-muted mt-0.5">Avant : {l.old_value}</div>}
                        </div>
                    ))}
                </div>
            )}
            <p className="text-[12px] text-content-muted px-1">Chaque changement de droit, accès aux données sensibles, suppression de compte est inscrit ici. Les actions d'agents IA y apparaîtront avec ce module.</p>
        </div>
    );
};
